<template>
  <transition name="fade">
    <div v-if="visible" class="cookie-banner">
      <div class="cookie-content">
        <b-row>
          <b-col md="8">
            <b style="font-size: 25px" class="text-primary"> Usamos Cookies </b>
            <p class="cookie-text">
              Utilizamos cookies para melhorar sua experiência, personalizar
              conteúdo e analisar o tráfego do site. Ao continuar navegando,
              você concorda com nossa
              <a href="/cookies">Política de Cookies</a> e
              <a href="/termos">Política de Privacidade</a>.
            </p>
          </b-col>
          <b-col md="4" class="d-flex align-items-center">
            <div class="cookie-actions">
              <button class="btn-ok" @click="acceptCookies">
                <b-icon-check-circle></b-icon-check-circle> Aceitar
              </button>
              <button class="btn-secondary"  @click="acceptCookies">
                 Apenas essenciais
              </button>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </transition>
</template>

<script>
import { ref, onMounted } from "vue";

export default {
  name: "CookieConsent",
  setup() {
    const STORAGE_KEY = "cookie_consent_accepted";
    const visible = ref(false);

    onMounted(() => {
      const accepted = localStorage.getItem(STORAGE_KEY);
      if (!accepted) {
        visible.value = true;
      }
    });

    function acceptCookies() {
      localStorage.setItem(STORAGE_KEY, "true");
      visible.value = false;
    }

    function closeBanner() {
      visible.value = false;
    }

    return {
      visible,
      acceptCookies,
      closeBanner,
    };
  },
};
</script>

<style scoped>
/* ================================
   VARIÁVEIS DE CORES (IDENTIDADE)
   ================================ */

/* ================================
   CONTAINER PRINCIPAL
   ================================ */
.cookie-banner {
  border-top: 2px solid var(--mx3-style-primary, #ff6600);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 20vh;
  min-height: 120px;
  background-color: #101214;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 16px;
  box-sizing: border-box;
}

/* ================================
   CONTEÚDO
   ================================ */
.cookie-content {
  max-width: 1200px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.cookie-text {
  color: white;
  font-size: 14px;
  line-height: 1.5;
}

/* ================================
   BOTÕES
   ================================ */
.cookie-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.cookie-actions button {
  padding: 10px 18px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  transition: opacity 0.2s ease;
}

.cookie-actions button:hover {
  opacity: 0.85;
}

.btn-ok {
  background-color: var(--mx3-style-primary, #ff6600);
  color: black;
}

.btn-close {
  background-color: var(--cookie-button-close);
  color: var(--cookie-button-close-text);
}

/* ================================
   RESPONSIVIDADE
   ================================ */
@media (max-width: 768px) {
  .cookie-banner {
    height: auto;
  }

  .cookie-content {
    gap: 12px;
  }

  .cookie-actions {
    flex-direction: column;
    width: 100%;
  }

  .cookie-actions button {
    width: 100%;
  }
}

/* ================================
   ANIMAÇÃO FADE
   ================================ */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
